// extracted by mini-css-extract-plugin
export default {"Container":"NotFound_Container__tRN-Y","Status":"NotFound_Status__OzS1v","Message":"NotFound_Message__YG1Tf"};